import { patchNhostStorageHeaders } from '@main/shared/utils';
import { NhostClient } from '@nhost/nhost-js';

export const nhost = new NhostClient({
  authUrl: import.meta.env.VITE_NHOST_AUTH_URL,
  functionsUrl: ' ',
  graphqlUrl: import.meta.env.VITE_NHOST_GRAPHQL_URL,
  storageUrl: import.meta.env.VITE_NHOST_STORAGE_URL,
});

patchNhostStorageHeaders({ nhostClient: nhost, getRole: () => 'admin' });
